import { __awaiter, __generator } from "tslib";
export var createRadioGroupDriver = function (wrapper, immediate) {
    if (immediate === void 0) { immediate = false; }
    var radioGroup = immediate ? wrapper : wrapper.$('.radio-group');
    var radioButtons = radioGroup.$$('.radio-button');
    return {
        getSelectedValue: function () { return __awaiter(void 0, void 0, void 0, function () {
            var radioItems, radioItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, radioButtons.filter(function (i) { return i.hasClass('checked'); })];
                    case 1:
                        radioItems = _a.sent();
                        return [4 /*yield*/, radioItems.count()];
                    case 2:
                        radioItem = (_a.sent()) ? radioItems.get(0) : null;
                        if (!radioItem) {
                            throw new Error('checked radio button does not exist');
                        }
                        return [4 /*yield*/, radioItem.attr('data-value')];
                    case 3: return [2 /*return*/, (_a.sent()) || ''];
                }
            });
        }); },
        selectByValue: function (value) { return __awaiter(void 0, void 0, void 0, function () {
            var radioItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        radioItem = radioButtons
                            .filter(function (i) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, i.attr('data-value')];
                                case 1: return [2 /*return*/, (_a.sent()) === value];
                            }
                        }); }); }).get(0) || '';
                        if (!radioItem) return [3 /*break*/, 2];
                        return [4 /*yield*/, radioItem.$('input').enterValue('')];
                    case 1:
                        _a.sent(); // fixes an issue with radio onchange call
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); },
        isRadioButtonDisabled: function (idx) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, radioButtons.get(idx).hasClass('disabled')];
        }); }); }
    };
};
//# sourceMappingURL=driver.js.map